import { Component, Signal, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideHouse, lucideInbox, lucideMenu, lucideSettings, lucideSettings2 } from '@ng-icons/lucide';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmNavigationMenuImports } from '@spartan-ng/helm/navigation-menu';
import { HlmSheetImports } from '@spartan-ng/helm/sheet';
import { PartCreationService } from '../../../features/parts/services/part-creation.service';
import { MenuButton } from '../../models/menu-button.model';
import { NavigationItems } from '../../models/navigation-item';
import { AuthService } from '../../services/auth.service';
import { AddPartMenu } from '../add-part-menu/add-part-menu';
import { Logo } from '../logo/logo';
import { NotificationsButton } from '../notifications-button/notifications-button';
import { SapTokenButton } from '../sap-token-button/sap-token-button';
import { UserMenu } from '../user-menu/user-menu';

/**
 * Top bar of the application (Figma "AppHeader", node 26:1546): logo, main navigation and the
 * global actions. Below the `md` breakpoint the navigation moves into a sheet behind a menu button.
 */
@Component({
  selector: 'app-header',
  templateUrl: './app-header.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgIcon,
    TranslatePipe,
    HlmButtonImports,
    HlmNavigationMenuImports,
    HlmSheetImports,
    Logo,
    NotificationsButton,
    SapTokenButton,
    UserMenu,
    AddPartMenu,
  ],
  providers: [provideIcons({ lucideHouse, lucideInbox, lucideMenu, lucideSettings, lucideSettings2 })],
  host: { class: 'block' },
})
export class AppHeader {
  private readonly authService = inject(AuthService);
  private readonly partCreationService = inject(PartCreationService);

  /** Navigation entries the signed-in user may open, in display order. */
  public readonly menus: Signal<MenuButton[]> = computed(() => NavigationItems.filter(item =>
    (item.permissions === undefined || this.authService.isAuthorized(item.permissions)())
    && (item.roles === undefined || this.authService.isInRole(item.roles)())
  ));
  public readonly canCreateParts = computed(() => this.partCreationService.canCreateParts());
}
